import type { LoginLifeguardRequest } from "../../../../api/client/types/auth.types";
import { WelcomeMessage } from "../../../../shared/components/ui/WelcomeMessage";
import { useAuthStore } from "../../../../store/auth/auth.store";
import { useGetBuildings } from "../../../buildings/services/buildingService";
import { useGetUserById } from "../../../users/services/userService";
import { LifeguardLoginForm } from "../../components/LifeguardLoginForm/LifeguardLoginForm";
import { useLoginLifeguard } from "../../services/authService";

/**
 * LifeguardLoginPage
 * Page component for lifeguard building selection and login.
 */
export const LifeguardLoginPage: React.FC = () => {
  const { user } = useAuthStore();
  const { data: currentUser } = useGetUserById(user?.id ?? "");

  const { mutate: loginLifeguard, isPending: isSubmitting } =
    useLoginLifeguard();

  const { data: buildings } = useGetBuildings({
    page: 1,
    page_size: 1000,
    status: "ACTIVE",
  });

  // Login handler
  const onLogin = (data: LoginLifeguardRequest) => {
    loginLifeguard(data);
  };

  return (
    <div className="flex flex-col gap-4 px-3 sm:px-6 py-4">
      <WelcomeMessage name={currentUser?.name} />
      <div className="flex items-center justify-center">
        <LifeguardLoginForm
          onLogin={onLogin}
          isSubmitting={isSubmitting}
          buildings={buildings?.items ?? []}
        />
      </div>
    </div>
  );
};
